module.exports = __webpack_public_path__ + "img/choose_list_2.51e80a66.png";